// module
import React from 'react';
import PropTypes from 'prop-types';

class CommandBox extends React.Component{
    render(){
        const {lines} = this.props;
        return(
            <div className="content_command_box">
                {lines.map( (line, idx) => {
                    if(line.data === "\n"){
                        return <br key={idx}/>;
                    }
                    return <label key={idx}>{line.data}<br/></label>;
                })}
            </div>
        );
    }
}

CommandBox.propTypes={
    lines: PropTypes.array.isRequired,
}

export default CommandBox;